import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  q: string;
  a: string;
}
const FAQS: FAQItem[] = [{
  q: 'How long does a shingle roof last in Michigan?',
  a: 'A quality architectural shingle roof typically lasts 25–30 years in Michigan, though our freeze-thaw cycles, ice dams, and severe storms can shorten that for poorly-installed roofs. Premium shingles with proper ventilation often last the full warranty period.'
}, {
  q: 'When is the best time of year to replace a roof in Michigan?',
  a: "Late spring through early fall (May–October) is ideal because shingles seal properly in warmer temperatures. That said, we install year-round when needed — emergency replacements after storm damage shouldn't wait. We use cold-weather installation techniques when temperatures drop."
}, {
  q: 'How do I prevent ice dams on my new roof?',
  a: 'Ice dams are caused by heat escaping into your attic, melting snow that refreezes at the eaves. Every Moceri roof replacement includes premium ice & water shield along the eaves and valleys, plus we inspect your attic ventilation and insulation to prevent ice dams from forming in the first place.'
}, {
  q: 'My roof was damaged in a Michigan storm. Will insurance cover replacement?',
  a: "Often yes — hail, wind, and fallen tree damage are typically covered by homeowner's insurance. We work directly with insurance adjusters and can document storm damage to support your claim. Call us first before filing if possible."
}, {
  q: 'How long does the roof replacement actually take?',
  a: "Most residential shingle roof replacements are completed in 1–2 days depending on size and complexity. We arrive early, work efficiently, and finish with a full property cleanup. You won't need to leave home during installation."
}, {
  q: 'Do you offer financing for roof replacements?',
  a: 'Yes — we work with several financing partners to make a new roof affordable, including options with low monthly payments and zero-interest promotional terms. Ask about financing during your free quote.'
}, {
  q: 'What kind of warranty comes with a Moceri shingle roof?',
  a: "Our premium architectural shingles come with manufacturer warranties of 30 years, 50 years, or lifetime depending on the product you select. We also back our workmanship — if something isn't right, we make it right."
}, {
  q: 'Will you clean up all the nails and debris?',
  a: 'Absolutely. We tarp your landscaping before work begins, haul away all old roofing material, and perform a thorough magnetic sweep of your yard, driveway, and surrounding areas. No stray nails — guaranteed.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-white py-20 sm:py-24" data-id="element-66">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="text-center mb-12" data-id="element-68">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-69">
            FAQ
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-4" data-id="element-70">
            Questions From Michigan Homeowners
          </h2>
          <p className="text-lg text-slate-600" data-id="element-71">
            The most common questions we hear about shingle roof replacement.
          </p>
        </div>

        <div className="space-y-3" data-id="element-72">
          {FAQS.map((faq, i) => {
          const isOpen = openIdx === i;
          return <div key={faq.q} className={`border rounded-xl overflow-hidden transition-all ${isOpen ? 'border-[#2DB8E0] shadow-md' : 'border-slate-200'}`} data-id="element-73">
                <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left bg-white hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2DB8E0]" aria-expanded={isOpen} data-id="element-74">
                  <span className="font-bold text-[#1a2332] text-base sm:text-lg" data-id="element-75">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180 text-[#2DB8E0]' : 'text-slate-400'}`} data-id="element-76" />
                </button>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-77">
                  <div className="overflow-hidden" data-id="element-78">
                    <p className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-79">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}